<template>
<div class="chapter">
<div class="inner_page">
<p><a id="c01"></a></p>
<div class="ct sgc-1">
    being here
  </div>
<div class="tx1">
    Listless blight, safe words, every little<br/>
    Sound in the night is a gasp—bone tip
  </div>
<div>
     <br/>
</div>
<div class="tx1">
    Blossoming through skin. It’s no<br/>
    Bull, man. Anymore, we’re all winners
  </div>
<div>
     <br/>
</div>
<div class="tx1">
    &amp; afraid to pull these faces off.<br/>
    Maple leaves &amp; plastic bags somersault
  </div>
<div>
     <br/>
</div>
<div class="tx1">
    Through the park. One cloud<br/>
    Grips the moon. Call me anything
  </div>
<div>
     <br/>
</div>
<div class="tx1">
    Before morning comes, little lover,<br/>
    Because it’s true &amp; doesn’t fucking matter.
  </div>
<div>
     <br/>
</div>
<div class="tx1">
    Kill the lights. Feel the burn. Rev yourself<br/>
    Up &amp; sing along with the good thrum
  </div>
<div>
     <br/>
</div>
<div class="tx1">
    Found in everything. Hang around<br/>
    Until the end. Melt my ashes on your tongue.
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alex_9781571318060_oeb_c01_r1.vue?8995c278